<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                     <div class="d-flex justify-end">
                         <div class="d-none d-sm-block">
                            <v-btn-group
                                variant="flat"
                                density="comfortable"
                                color="primary"
                                divided
                                >
                                <!-- <Link :href="route('companies.manage')">
                                    <v-btn text="Create Company" class="h-100">
                                        <template #prepend>
                                            <mdi-icon>add</mdi-icon>
                                        </template>
                                    </v-btn>
                                </Link> -->
                                <v-btn @click="router.visit(route('companies.manage'))" text="Create Company" class="h-100">
                                    <template #prepend>
                                        <mdi-icon>add</mdi-icon>
                                    </template>
                                </v-btn>
                                <v-btn class="px-2 min-w-auto" v-tooltip="`Upload File`" color="btn-secondary" @click="uploadDialogRef?.open">
                                    <mdi-icon>cloud_upload</mdi-icon>
                                </v-btn>
                             </v-btn-group>
                         </div>
                         <div class="d-sm-none">
                             <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                 <mdi-icon :size="tableCard.actionMenu.btn.iconSize">{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                 <v-menu activator="parent" class="tiny-dropdown">
                                     <v-list>
                                         <Link class="v-list-item-n-link" :href="route('companies.manage')">
                                             <v-list-item title="Create Company" value="create_company">
                                                 <template #prepend>
                                                     <mdi-icon>add</mdi-icon>
                                                 </template>
                                             </v-list-item>
                                         </Link>
                                         <v-list-item title="Upload File" value="create_company_by_file"  @click="uploadDialogRef?.open">
                                            <template #prepend>
                                                <mdi-icon>cloud_upload</mdi-icon>
                                            </template>
                                        </v-list-item>
                                     </v-list>
                                 </v-menu>
                             </v-btn-icon>
                         </div>
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                         <template v-slot:[`item.sign_status`]="{ item }:{item: Company}" key="item.sign_status">
                             <div :class="`fw-medium text-${item?.sign_status_preview?.color ?? 'secondary'}`">{{ item?.sign_status_preview?.name ?? 'Not found' }}</div>
                         </template>
                         <template v-slot:[`item.action`]="{ item }:{item: Company}" key="item.action">
                             <div>
                                 <div class="d-none d-md-block">
                                     <div class="d-flex justify-center">
                                         <v-tooltip text="Edit" v-if="!item.is_sent">
                                             <template v-slot:activator="{ props }">
                                                 <Link :href="route('companies.manage', item.id)" v-bind="props">
                                                     <v-btn-icon-text color="primary">
                                                         <mdi-icon>edit_square</mdi-icon>
                                                     </v-btn-icon-text>
                                                 </Link>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Send Agreement" v-if="!item.is_sent">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="warning" v-bind="props" @click.prevent="confirmSendingDoc(item, false)">
                                                    <mdi-icon>send</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Send Reminder" v-if="item.is_sent && !item.is_signed">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="warning"  v-bind="props" @click.prevent="confirmSendingDoc(item, true)">
                                                    <mdi-icon>notifications_active</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Create Invoice" v-if="item.is_signed">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="primary"  v-bind="props" @click.prevent="openInviceDialog(item.id as number)">
                                                    <mdi-icon>receipt_long</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                     </div>
                                 </div>
                                 <div class="d-md-none">
                                     <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                         <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                         <v-menu activator="parent" class="tiny-dropdown">
                                             <v-list min-width="120px" >
                                                 <Link class="v-list-item-n-link" :href="route('companies.manage', item.id)" v-if="!item.is_sent">
                                                     <v-list-item title="Edit" value="edit_admin">
                                                         <template #prepend>
                                                             <mdi-icon>edit_square</mdi-icon>
                                                         </template>
                                                     </v-list-item>
                                                 </Link>
                                                <v-list-item title="Send Agreement" value="sent_document" v-if="!item.is_sent" @click.prevent="confirmSendingDoc(item, false)">
                                                    <template #prepend>
                                                        <mdi-icon>send</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item title="Send Reminder" value="sent_document_reminder" v-if="item.is_sent && !item.is_signed" @click.prevent="confirmSendingDoc(item, true)">
                                                    <template #prepend>
                                                        <mdi-icon>notifications_active</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item title="Create Invoice" value="create_invoice" v-if="item.is_signed" @click.prevent="openInviceDialog(item.id as number)">
                                                    <template #prepend>
                                                        <mdi-icon>receipt_long</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                             </v-list>
                                         </v-menu>
                                     </v-btn-icon>
                                 </div>
                             </div>
                             
                         </template>
                     </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>
         <!-- API Token delete confirm Modal -->
         <v-dialog v-model="sendingDoc" width="auto" @afterLeave="sendingDoc = false">
             <v-card max-width="100%" width="500">
                <template v-if="sendingDocAsReminder">
                    <v-card-title>Remind to sign Agreement</v-card-title>
                    <v-card-subtitle>Are you sure you want to send the reminder?</v-card-subtitle>
                </template>
                <template v-else>
                    <v-card-title>Send Agreement</v-card-title>
                    <v-card-subtitle>Are you sure you want to send this now?</v-card-subtitle>
                </template>
                 
                 <v-card-text class="py-2">
                     <div v-if="sendingDocForm.errors.custom_error" class="text-error">{{ sendingDocForm.errors.custom_error }}</div>
                 </v-card-text>
                 <v-card-actions-modal>
                     <v-btn
                         text="No"
                         color="btn-secondary"
                         @click="sendingDoc = false"
                     ></v-btn>
                     <v-btn
                         :disabled="sendingDocForm.processing"
                         :loading="sendingDocForm.processing"
                         @click="sendDoc"
                         color="primary"
                         text="Yes"
                     ></v-btn>
                 </v-card-actions-modal>
             </v-card>
         </v-dialog>
         <InvoiceDialog v-model="manageInvoiceDialog" v-model:company-id="invoiceDialogCompanyId"  ></InvoiceDialog>
         <UploadDialog :biller="page.props.data.biller" @on-success="() => { datatable.setTable(page.props.data.table) }" ref="uploadDialogRef"  ></UploadDialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm, router } from '@inertiajs/vue3';
    import { SharedDataPageProps } from '@/Types/inertia';
    import { Company } from '@/Types/Models/company';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import InvoiceDialog from '@/Pages/Invoices/Manage.vue';
    import UploadDialog from '@/Pages/Companies/UploadDialog.vue';
    import { Biller } from "@/Types/Models/biller";

    containerGapForTable();
    type PageData = SharedDataPageProps<{
        table?: TableResponse<Company>;
        biller: Biller,
    }>;
    const page = usePage<PageData>();
    pageTitle.value = 'Companies';
    const datatable = useDatatable<Company>(route('companies.index'), page.props.data.table);
    console.log(datatable.request.length)

    const sendingDocForm = useForm({
        custom_error: ''
    });
    const sendingDoc = ref(false);
    const sendingDocAsReminder = ref(false);
    const docBeingSent = ref<Company | null>(null);
    const confirmSendingDoc = async (company: Company, isReminder: boolean = true) => {
        sendingDocForm.reset();
        sendingDocForm.clearErrors();
        sendingDocAsReminder.value = isReminder;
        docBeingSent.value = company;
        sendingDoc.value = true;
    };

    const sendDoc = () => {
        sendingDocForm.post(route('companies.send', docBeingSent.value?.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
            sendingDocForm.reset();
                docBeingSent.value = null;
                sendingDoc.value = false;
                sendingDocAsReminder.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Agreement is sent');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    const tableCard = useTableCard();
    
    const manageInvoiceDialog = ref(false);
    const invoiceDialogCompanyId = ref(0);
    const invoiceDialogInvoiceId = ref(0);
    const openInviceDialog = (companyId: number) => {
        invoiceDialogCompanyId.value = companyId;
        manageInvoiceDialog.value = true;
    }

    type UploadDialogRef = InstanceType<typeof UploadDialog>;
    const uploadDialogRef = ref<UploadDialogRef | null>(null);

 </script>